import axios from '../wmsAxios'

/*
 * 全局Source管理
 */

// 查询仓库列表
export const getWhse = (data) => {
    return axios({
      url: '/globalOptions/getWhse',
      method: 'post',
      data
  })
}

// 查询货主列表
export const getClient = (data) => {
  return axios({
      url: '/globalOptions/getClient',
      method: 'post',
      data
  })
}

// 添加收货记录
export const addReceipt = (data) => {
  return axios({
    url: '/globalOptions/addReceipt',
    method: 'post',
    data
  })
}

// 查询t_lookup资源
export const getLookup = (data) => {
  return axios({
    url: '/globalOptions/getLookup',
    method: 'post',
    data
  })
}

// 查询供应商
export const getVendor = (data) => {
  return axios({
    url: '/globalOptions/getVendor',
    method: 'post',
    data
  })
}

// 查询承运商
export const getCarrier = (data) => {
  return axios({
    url: '/globalOptions/getCarrier',
    method: 'post',
    data
  })
}

// 查询叉车
export const getFork = (data) => {
  return axios({
    url: '/globalOptions/getFork',
    method: 'post',
    data
  })
}

// 查询菜单
export const getMenu = (data) => {
  return axios({
    url: '/globalOptions/getMenu',
    method: 'post',
    data
  })
}

// 查询菜单
export const getLocaleIdByUser = (data) => {
  return axios({
    url: '/globalOptions/getLocaleIdByUser',
    method: 'post',
    data
  })
}

// 查询拣选方式
export const getWorkType = (data) => {
  return axios({
    url: '/globalOptions/getWorkType',
    method: 'post',
    data
  })
}

// 查询上架类别
export const getClassByParam = (data) => {
  return axios({
    url: '/globalOptions/getClassByParam',
    method: 'post',
    data
  })
}

// 查询动态属性集合
export const getAttributeCollection = (data) => {
  return axios({
    url: '/globalOptions/getAttributeCollection',
    method: 'post',
    data
  })
}

// 查询商品装箱类别
export const getItemType = (data) => {
  return axios({
    url: '/globalOptions/getItemType',
    method: 'post',
    data
  })
}

// 查询商品
export const getSku = (data) => {
  return axios({
    url: '/globalOptions/getSku',
    method: 'post',
    data
  })
}

// 查询库位
export const getLocation = (data) => {
  return axios({
    url: '/globalOptions/getLocation',
    method: 'post',
    data
  })
}

// 查询商品动态属性
export const getItemAttributeTypes = (data) => {
  return axios({
    url: '/globalOptions/getItemAttributeTypes',
    method: 'post',
    data
  })
}

// 查询商品批次控制和动态属性集合ID
export const getItemLotCtlAttrCollection = (data) => {
  return axios({
    url: '/globalOptions/getItemLotCtlAttrCollection',
    method: 'post',
    data
  })
}
// 获取商品库存动态属性ID
export const getStoredAttributeId = (data) => {
  return axios({
    url: '/globalOptions/getStoredAttributeId',
    method: 'post',
    data
  })
}

// 获取商品基本单位
export const getItemBaseUom = (data) => {
  return axios({
    url: '/globalOptions/getItemBaseUom',
    method: 'post',
    data
  })
}

// 获取库位托盘标识
export const getLocItemHuIndicate = (data) => {
  return axios({
    url: '/globalOptions/getLocItemHuIndicate',
    method: 'post',
    data
  })
}

// 获取目标库位列表
export const getDestinationLocation = (data) => {
  return axios({
    url: '/globalOptions/getDestinationLocation',
    method: 'post',
    data
  })
}

// 获取库区列表
export const getZone = (data) => {
  return axios({
    url: '/globalOptions/getZone',
    method: 'post',
    data
  })
}

// 获取商品库存动态属性列表
export const getStoAttributesByItem = (data) => {
  return axios({
    url: '/globalOptions/getStoAttributesByItem',
    method: 'post',
    data
  })
}

// 获取原因下拉列表
export const getReason = (data) => {
  return axios({
    url: '/globalOptions/getReason',
    method: 'post',
    data
  })
}

// 获取道口下拉列表
export const getDockDoor = (data) => {
  return axios({
    url: '/globalOptions/getDockDoor',
    method: 'post',
    data
  })
}

// 获取发货暂存区下拉列表
export const getDockDoorStagingLoc = (data) => {
  return axios({
    url: '/globalOptions/getDockDoorStagingLoc',
    method: 'post',
    data
  })
}

// 获取不同状态的订单数
export const getOrdersByStatus = (data) => {
  return axios({
    url: '/globalOptions/getOrdersByStatus',
    method: 'post',
    data
  })
}

// 获取不同状态的库位数
export const getLocatonsByZone = (data) => {
  return axios({
    url: '/globalOptions/getLocatonsByZone',
    method: 'post',
    data
  })
}

// 获取AccessToken
export const getAccessToken = (data) => {
  return axios({
    url: '/globalOptions/getAccessToken',
    method: 'post',
    data
  })
}

// 查询箱型类别
export const getCartonType = (data) => {
  return axios({
    url: '/globalOptions/getCartonType',
    method: 'post',
    data
  })
}

// 获取各库区临期产品数量
export const getExpiryDateItemsByZone = (data) => {
  return axios({
    url: '/globalOptions/getExpiryDateItemsByZone',
    method: 'post',
    data
  })
}

// 商品下拉搜索（按仓库+关键字）
export const searchItems = (data) => {
  return axios({
    url: '/tItemMaster/searchItems',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/globalOption.js